/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NoopPlaceholder,
  NoopPlaceholderInterface,
} from "../NoopPlaceholder";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class NoopPlaceholder__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NoopPlaceholder> {
    return super.deploy(overrides || {}) as Promise<NoopPlaceholder>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): NoopPlaceholder {
    return super.attach(address) as NoopPlaceholder;
  }
  connect(signer: Signer): NoopPlaceholder__factory {
    return super.connect(signer) as NoopPlaceholder__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NoopPlaceholderInterface {
    return new utils.Interface(_abi) as NoopPlaceholderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NoopPlaceholder {
    return new Contract(address, _abi, signerOrProvider) as NoopPlaceholder;
  }
}
